import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 2
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#1a0808',
    borderTop: '1px solid rgba(255, 68, 68, 0.2)',
    borderBottom: '1px solid rgba(255, 68, 68, 0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-62">
      <div className="mx-auto max-w-3xl text-center" data-id="element-63">
        <h2 className="text-lg sm:text-2xl font-black text-white m-0 mb-6" data-id="element-64">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-4" data-id="element-65">
          <div className="flex items-center justify-center gap-2" data-id="element-66">
            <div className="flex flex-col items-center" data-id="element-67">
              <span className="text-4xl sm:text-6xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-68">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-69">
                hs
              </span>
            </div>

            <span className="mb-4 text-4xl sm:text-6xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-70">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-71">
              <span className="text-4xl sm:text-6xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-72">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-73">
                min
              </span>
            </div>

            <span className="mb-4 text-4xl sm:text-6xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-74">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-75">
              <span className="text-4xl sm:text-6xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-76">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-77">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-base font-bold text-gray-300 m-0 mb-8" data-id="element-78">
          Después sube{' '}
          <span className="font-black text-red-400" data-id="element-79">$8.000 ARS</span> y no
          vuelve a bajar.
        </p>

        <div className="mb-4 mx-auto max-w-xl" data-id="element-80">
          <div className="mb-1 flex items-center justify-between" data-id="element-81">
            <span className="text-xs font-bold text-red-400" data-id="element-82">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold text-gray-300" data-id="element-83">
              Quedan pocos
            </span>
          </div>
          <div className="h-3 w-full overflow-hidden bg-white/10 rounded-full" data-id="element-84">
            <div className="h-3 rounded-full" style={{
            width: '68%',
            backgroundImage: 'linear-gradient(to right, rgb(255, 0, 0), rgb(255, 102, 0))'
          }} data-id="element-85" />
          </div>
          <p className="text-right text-[10px] text-gray-500 mt-1 mb-0" data-id="element-86">
            68% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}